export function pcpToThdCanadaAnalytics(storeState, cultureCode) {
  var _pricing$pricing, _pricing$pricing$stri, _pricing$pricing2, _pricing$pricing2$str;

  const configurator = storeState.configurator,
        applicationState = storeState.applicationState;
  const productInfo = configurator.productInfo,
        pricing = configurator.pricing;

  const _ref = productInfo || {},
        productId = _ref.partnerProductId,
        brand = _ref.brand,
        name = _ref.productName;

  const quantity = applicationState.quantity,
        configurationGuid = applicationState.configurationGuid;
  const _window = window,
        breadcrumbs = _window.breadCrumbs; // Calculate pricing

  const unitPrice = (_pricing$pricing = pricing.pricing) == null ? void 0 : (_pricing$pricing$stri = _pricing$pricing.strikeThroughPrice) == null ? void 0 : _pricing$pricing$stri.Price;
  const basePrice = Number.parseFloat((unitPrice * quantity).toFixed(2));
  const vendorDiscount = (_pricing$pricing2 = pricing.pricing) == null ? void 0 : (_pricing$pricing2$str = _pricing$pricing2.strikeThroughPrice) == null ? void 0 : _pricing$pricing2$str.PriceSavings;
  let pageName = '';
  let productCategory = ''; // Get additional data from digitalData global

  if (window.digitalData) {
    var _digitalData$page, _digitalData$page$pag, _product$productInfo;

    const _window2 = window,
          digitalData = _window2.digitalData;
    const product = digitalData == null ? void 0 : digitalData.product[0];
    pageName = digitalData == null ? void 0 : (_digitalData$page = digitalData.page) == null ? void 0 : (_digitalData$page$pag = _digitalData$page.pageInfo) == null ? void 0 : _digitalData$page$pag.pageName;
    productCategory = product == null ? void 0 : (_product$productInfo = product.productInfo) == null ? void 0 : _product$productInfo.productCategory;
  }

  return {
    pageDetail: {
      pageName,
      pageSiteSection: pageName,
      language: (cultureCode == null ? void 0 : cultureCode.split('-')[0]) || 'en',
      breadcrumbs: breadcrumbs == null ? void 0 : breadcrumbs.map(bc => ({
        title: bc.name,
        url: bc.href
      }))
    },
    productOverview: {
      name,
      productId,
      quantity,
      customized: {
        productCategory,
        brand,
        guid: configurationGuid,
        unitPrice,
        basePrice,
        cost: basePrice,
        vendorDiscount,
        eligible: true,
        availableShippingOption: 'standard'
      }
    }
  };
}
export function pcpAddToCartToThdCanadaAnalytics({
  productInfo,
  pricing,
  quantity
}) {
  const location = 'custom blinds configurator';
  return {
    atcItems: {
      items: [{
        displayPrice: pricing.pricing.strikeThroughPrice.Price,
        displayShippingMethod: 'sth',
        isCartSwitch: true,
        itemQuantityActual: quantity,
        itemQuantityRequest: quantity,
        customized: {
          eligible: true
        },
        product: {
          brand: productInfo.brand,
          code: productInfo.partnerProductId,
          name: productInfo.siteProductName
        },
        productInteractionLocation: location,
        productInteractionLocationTitle: location,
        productInteractionLocationType: location,
        productInteractionPageType: 'product configurator page'
      }]
    },
    multiATCEnabled: false,
    search: {},
    navigationBlock: {
      location,
      type: 'submit button click',
      value: 'Add To Cart'
    }
  };
}
export default pcpToThdCanadaAnalytics;